import { ConversationCard, RecirculationSlider } from "open-modules/cbcrc/component/recirculationCards";
import { EditorialReadingListWidget } from "open-modules/cbcrc/feature/topic/editorial-reading-list";
import { CLICK } from "system/demo";

export const baseComponentsDemo = [
    { label: 'Recirculation cards', key: 'recirculation-cards', storySets: recirculationCardsStorySets, designUrl: 'https://www.figma.com/design/MX0AcO8d0ZlCBs4e9vkl5f/PSI-Design-System?node-id=6312-22463&t=ulUnkS0T6jFNKQyd-1' },
];

const recirculationCollections = {
    derived_relatedQuestionPreview: [
        { key: 'question-1', commentPreview: {
            from: 'b',
            text: 'Random comment',
            time: 1733775285001,
        }, participantCount: 2 },
        { key: 'question-2', commentPreview: {
            from: 'a',
            text: 'Some comment',
            time: 1733775285001,
        }, participantCount: 3 },
        { key:'question-3', commentPreview: {
            from: 'c',
            text: 'Some other comment',
            time: 1733775285001,
        }, participantCount: 5 },
    ],
    relatedConversations: [
        {
            key: 'question-1',
            id: 'question-1',
            from: 'a',
            text: 'Is Godzilla good?',
        },
        {
            key: 'question-2',
            id: 'question-2',
            from: 'b',
            text: 'Is Kong bad?',
        },
        {
            key: 'question-3',
            id: 'question-3',
            from: 'c',
            text: 'Would you watch Gozilla vs Kong?',
        },
    ]
};

const relatedArticles = [
    {
        id: 1,
        picture: "https://placehold.co/250x150",
        published: true,
        text: "A text article",
        type: "text",
        url: 'https://www.google.com',
    },
    {
        id: 2,
        picture: "https://placehold.co/250x150",
        published: true,
        text: "An audio article",
        type: "audio",
        url: 'https://www.google.com',
    },
    {
        id: 3,
        picture: "https://placehold.co/250x150",
        published: true,
        text: "A media article",
        type: "media",
        url: 'https://www.google.com',
    },
    {
        id: 4,
        picture: "https://placehold.co/250x150",
        published: true,
        text: "A text article",
        type: "text",
        url: 'https://www.google.com',
    },
];

function recirculationCardsStorySets() {
    return [
        {
            label: 'Conversation Card - Single card',
            collections: recirculationCollections,
            content: <ConversationCard
                id={"question-1"}
                text={"Is King Kong Bad?"}
                singleCard={true}
            />,
            stories: [
                {
                    label: 'Click on card',
                    actions: [
                        CLICK('conversation-card-question-1'),
                    ]
                }
            ]
        },
        {
            label: 'Conversation Card - Multiple cards',
            collections: recirculationCollections,
            stories: [
                {
                    label: 'Navigate in the slider',
                    actions: [
                        CLICK('Next'),
                        CLICK('Next'),
                        CLICK('Previous')
                    ],
                },
            ],
            content: <RecirculationSlider cardsData={recirculationCollections.relatedConversations} controls />
        },
        {
            label: 'Editorial Reading List',
            collections: {
                relatedArticles: relatedArticles,
            },
            content: <EditorialReadingListWidget />,
        }
    ]
}
